<template>
  <div
    id="faqs-hero-section"
    class="tw-mt-10 lg:tw-bg-gray-lightest lg:tw-px-16"
  >
    <div class="hero-section-container">
      <div class="tw-px-4">
        <div class="tw-mt-20 tw-pt-20 lg:tw-py-32">
          <h3
            class="tw-bg-primary tw-text-2xl md:tw-text-5xl tw-text-white tw-font-semibold tw-rounded-2xl tw-text-center tw-px-4 tw-py-10 md:tw-py-24"
          >
            Frequently Asked Questions (FAQs)
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FaqHeroSection",
};
</script>

<style lang="scss" scoped>
#faqs-hero-section {
  .hero-section-container {
    margin: auto;

    @media screen and (min-width: 1280px) {
      max-width: 1200px;
    }

    @media screen and (min-width: 1960px) {
      max-width: 1280px;
    }
  }
}
</style>
